export default [
    {
        value:'Essential Goods & Food',
        label:'Essential Goods & Food',
        
        children: [{
            value:'Vegetables & Fruits',
            label:'Vegetables & Fruits'
        },{
            value: 'Supermarket',
            label: 'Supermarket'
        },{
            value:'Grocery',
            label:'Grocery'
        },{
            value:'Food / Restaurants',
            label:'Food / Restaurants'
        },{
            value:'Agri Products',
            label:'Agri Products'
        }]
    },
{
value: 'Clothing',
label: 'Clothing',
         
    children: [{
    value: 'Men’s & Women’s Clothing',
    label: 'Men’s & Women’s Clothing'
},{
    value: 'Men’s Clothing',
    label: 'Men’s Clothing'
},{
    value: 'Women’s Clothing',
    label: 'Women’s Clothing'
}]},


{
    value: 'Vehicles',
    label: 'Vehicles',
             
        children: [{
        value: 'All Vehicles',
        label: 'All Vehicles'
    },{
        value: 'Car',
        label: 'Car'
    },{
        value: 'Van',
        label: 'Van'
    },,{
        value: 'Jeep & Pickup',
        label: 'Jeep & Pickup'
    },,{
        value: 'Crew Cab',
        label: 'Crew Cab'
    },,{
        value: 'Bus',
        label: 'Bus'
    },,{
        value: 'Lorry',
        label: 'Lorry'
    },,{
        value: 'Tipper',
        label: 'Tipper'
    },,{
        value: 'Truck',
        label: 'Truck'
    },,{
        value: 'Three Wheeler',
        label: 'Three Wheeler'
    },,{
        value: 'Motorcycle',
        label: 'Motorcycle'
    },,{
        value: 'Heavy-Duty & Land Vehicle',
        label: 'Heavy-Duty & Land Vehicle'
    },{
        value: 'Agriculture Machinery',
        label: 'Agriculture Machinery'
}]},

{
    value: 'Auto Parts',
    label: 'Auto Parts',
             
        children: [{
        value: 'All Vehicles',
        label: 'All Vehicles'
    },{
        value: 'Car',
        label: 'Car'
    },{
        value: 'Van',
        label: 'Van'
    },,{
        value: 'Jeep & Pickup',
        label: 'Jeep & Pickup'
    },,{
        value: 'Crew Cab',
        label: 'Crew Cab'
    },,{
        value: 'Bus',
        label: 'Bus'
    },,{
        value: 'Lorry',
        label: 'Lorry'
    },,{
        value: 'Tipper',
        label: 'Tipper'
    },,{
        value: 'Truck',
        label: 'Truck'
    },,{
        value: 'Three Wheeler',
        label: 'Three Wheeler'
    },,{
        value: 'Motorcycle',
        label: 'Motorcycle'
    },,{
        value: 'Heavy-Duty & Land Vehicle',
        label: 'Heavy-Duty & Land Vehicle'
    },{
        value: 'Agriculture Machinery',
        label: 'Agriculture Machinery'
}]},

{
    value: 'Shoes & Footwear',
    label: 'Shoes & Footwear'
  },{
    value: 'Mobiles & Tablets',
    label: 'Mobiles & Tablets',
  },{
    value: 'Computers',
    label: 'Computers',
  },{
    value: 'Electronics',
    label: 'Electronics'
  },
  {
    value: 'Cameras',
    label: 'Cameras',
  },
  {
    value: 'Tools & Machines',
    label: 'Tools & Machines',
 },
{
    value: 'Home Appliances',
    label: 'Home Appliances',
  
      children: [{
      value: 'Household Supplies',
      label: 'Household Supplies'
  },{
      value: 'Tiles & Bathware',
      label: 'Tiles & Bathware'
  },{
      value: 'Lighting & Electrical',
      label: 'Lighting & Electrical'
  },{
      value: 'Outdoor',
      label: 'Outdoor' 
  }]
},
{
    value: 'Home Decor',
    label: 'Home Decor',
    
    children: [{
      value: 'Home Decoration',
      label: 'Home Decoration'
  },{
      value: 'Window Treatments',
      label: 'Window Treatments'
  },{
     value: 'Handicrafts',
     label: 'Handicrafts',
  }]
  },
{
    value: 'Furniture',
    label: 'Furniture',
 },


{
    value: 'Health & Beauty',
    label: 'Health & Beauty'
},{
    value: 'Fancy Items',
    label: 'Fancy Items'
},

{
    value: 'Jewelry & Watches',
    label: 'Jewelry & Watches',
             
        children: [{
        value: 'Jewelry & Watches',
        label: 'Jewelry & Watches'
    },{
        value: 'Jewelry',
        label: 'Jewelry'
    },{
        value: 'Watches',
        label: 'Watches'
}]},

{
    value: 'Diamonds & Gems',
    label: 'Diamonds & Gems'
},{
    value: 'Baby Kids & Toys',
    label: 'Baby Kids & Toys'
},{
    value: 'Bags',
    label: 'Bags'                       
},
{
   value: 'Sports',
   label: 'Sports',
},{
   value: 'Music',
   label: 'Music',
},{
   value: 'Books',
   label: 'Books',
},
]


// WEBPACK FOOTER //
// ./src/data/shops.js